import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

interface UploadedImageInfo {
  mimetype: string;
  originalname: string;
  size: number;
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class CommonApiService {
  constructor(private http: HttpClient) {}

  uploadImage(imageFile: any): Observable<UploadedImageInfo[]> {
    const formData: FormData = new FormData();
    formData.append('file', imageFile);

    return this.http.post<any>(
      `${environment.bukOrigin}/api/2.0/image`,
      formData,
      { withCredentials: true }
    );
  }

  extractEmailFromFile(files: any): Observable<string[]> {
    const formData: FormData = new FormData();

    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      formData.append('file' + i, file, 'file' + i);
    }

    return this.http.post<string[]>(
      `${environment.bukOrigin}/api/2.0/extract/email`,
      formData
    );
  }
}
